<template>
  <i 
    :class="baseIconClasses" 
    class="base-icon" 
    v-on="$listeners"
  >
    {{ icon }}
  </i>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  icon: {
    type: String,
    required: true,
  },
  size: {
    type: String,
    default: "medium",
    validator: (value) => ["small", "medium", "large"].includes(value),
  },
  variation: {
    type: String,
    default: "rounded",
    validator: (value) => ["filled", "outlined", "rounded", "sharp"].includes(value),
  },
});

const baseIconClasses = computed(() => ({
  [`base-icon--size-${props.size}`]: true,
  [`base-icon--variation-${props.variation}`]: true,
}));
</script>

<style lang="scss" scoped>
@import "./base-icon.scss";
</style>
